export enum Direction {
    NORTH = "NORTH",
    SOUTH = "SOUTH"
}

export enum TrainType {
    PASSENGERTRAIN = "PASSENGERTRAIN",
    SERVICETRAIN = "SERVICETRAIN"
}

export enum CurrentLocationStatus {
    ARRIVED = "ARRIVED",
    DEPARTED = "DEPARTED"
}

export enum AnnouncementAgeLevel {
    LEVEL1 = "LEVEL1",
    LEVEL2 = "LEVEL2",
    LEVEL3 = "LEVEL3"
} 